// https://flow.org/blog/2015/03/12/Bounded-Polymorphism/
// https://github.com/babel/babel-eslint/issues/445#issuecomment-289592816
// https://github.com/babel/babel-eslint/pull/459

/* eslint-disable react/no-unused-prop-types, no-unused-vars */
import * as React from 'react';
import { isNil } from 'lodash';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import type { ContextMenuItem } from 'types';

type ExtendsContextMenuItemProps = {
  item: ContextMenuItem,
  onModalClosed?: (a: React.MouseEvent) => void
};

class ExtendsContextMenuItem<Props extends ExtendsContextMenuItemProps> extends React.PureComponent<Props> {
  renderIcon(item: ContextMenuItem): React.ReactNode | undefined | null {
    if (item.icon) {
      let iconComponent = item.icon;

      if (typeof item.icon === 'string') {
        iconComponent = (
          <SVGDynamicIcon
            name={item.icon}
            customColor="grey"
            clickable={isNil(item.iconClickable)}
            width={16}
            height={16}
          />
        );
      }

      return (
        <div className="context-menu-item__icon">
          {iconComponent}
        </div>
      );
    }

    return null;
  }
}

export default ExtendsContextMenuItem;
